module.exports = __webpack_public_path__ + "media/St 4-Question 13-incorrect.a5e357ad.wav";